import MatchedMap from 'utilities/src/matchedMap';

import { SiteVariantEnum } from '../_variants';

import buttonSitePrimaryClasses from './_primary';
import buttonSiteSecondaryClasses from './_secondary';
import buttonSiteTertiaryClasses from './_tertiary';
import buttonSiteTextOnlyClasses from './_textOnly';

const buttonSiteVariantClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, buttonSitePrimaryClasses],
  [SiteVariantEnum.Secondary, buttonSiteSecondaryClasses],
  [SiteVariantEnum.Tertiary, buttonSiteTertiaryClasses],
  [SiteVariantEnum.TextOnly, buttonSiteTextOnlyClasses],
]);

export default buttonSiteVariantClassesMap;
